import React, { useEffect, useRef } from 'react';
import type { MapLocation } from '@types';
import useToggle from '@hooks/useToggle';

interface Props {
  className?: string;
  location?: MapLocation;
  noMarker?: boolean;
}

function LocationMap({ className, location = {}, noMarker = false }: Props) {
  const containerRef = useRef<HTMLDivElement>(null);
  const mapRef = useRef<AMap.Map>();
  const markerRef = useRef<AMap.Marker>();
  const initFix = useToggle(); // 修复高德地图显示bug
  const ready = useToggle(false);

  const setPoint = (lng: number, lat: number) => {
    if (noMarker) return;
    if (markerRef.current) markerRef.current?.setMap(null);
    markerRef.current = new AMap.Marker({
      position: [lng, lat],
      map: mapRef.current,
    });
  };

  useEffect(() => {
    initFix.on();
  }, []);

  useEffect(() => {
    if (!initFix.isOn || !containerRef.current) return;
    mapRef.current = new AMap.Map(containerRef.current, {
      layers: [new AMap.TileLayer()],
      zoom: location?.zoom ?? 13,
      dragEnable: false,
    });
    const handleInit = () => {
      ready.on();
    };
    mapRef.current.on('complete', handleInit);
    return () => {
      mapRef.current?.off('complete', handleInit);
      mapRef.current?.destroy();
    };
  }, [initFix.isOn]);

  useEffect(() => {
    if (ready.isOn && location.lng && location.lat) {
      setPoint(location.lng, location.lat);
      mapRef.current?.setZoomAndCenter(
        location?.zoom ?? 13,
        [location.lng, location.lat],
        true
      );
    }
  }, [location, ready.isOn]);

  return (
    <div className={className}>
      <div className="h-full w-full" ref={containerRef} />
    </div>
  );
}

export default LocationMap;
